import React from "react";

interface StatCardProps {
  title: string;
  value: number;
  variant: "primary" | "success" | "warning" | "active" | "blocked";
}

const StatCard: React.FC<StatCardProps> = ({ title, value, variant }) => (
  <div className={`stat-card stat-card--${variant}`}>
    <span className="stat-card__title">{title}</span>
    <span className={`stat-card__value stat-value--${variant}`}>{value}</span>
  </div>
);

export default StatCard;
